export default {
  /** 查询任务列表 */
  getTaskList: '/api/tasks/list',
  /** 任务消息已读 */
  setTaskHasBeenRead: '/api/tasks/read',
  /** 查询未读消息数量 */
  getCountOfUnread: '/api/tasks/unread-count',
  /** 批量获取任务信息 */
  getTask: '/api/tasks/get',
  /** 订单同步 */
  orderSync: '/api/tasks/order-sync',
  /** 导出任务 */
  taskExport: '/api/tasks/export',
  /**更新订单*/
  orderUpdate: '/api/tasks/order-update',
  /**批量恢复订单 */
  batchRecoverUrl: '/api/sales/outbounds/batch-recover',
  /**批量导入 */
  batchImport: '/api/tasks/import',
}
